module.exports = __webpack_public_path__ + "static/image_12-1f43c359b21c151acb2935550f145f30.jpg";